import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import ContactInfo from "./contact/ContactInfo";
import ContactForm from "./contact/ContactForm";

const Contact = () => {
  const { t } = useLang();
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-24 sm:py-32 bg-[#F9F6F0]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
          <div>
            <p className="text-[#2E4F4F] text-xs uppercase tracking-[0.3em] mb-4">
              {t.contact.eyebrow}
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl text-[#1A1F24] tracking-tight mb-12">
              {t.contact.title}
            </h2>
            <ContactInfo />
          </div>
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default Contact;
